import React from 'react';
import { StyledIncludedIcon, StyledNotIncludedIcon, StyledProductFeaturesListItem } from './styled';
var NotIncludedIcon = function NotIncludedIcon(_ref) {
  var excludedAreaLabel = _ref.excludedAreaLabel;
  return /*#__PURE__*/React.createElement(StyledNotIncludedIcon, {
    "aria-label": excludedAreaLabel
  });
};
var IncludedIcon = function IncludedIcon(_ref2) {
  var baseTestId = _ref2.baseTestId,
    includedAreaLabel = _ref2.includedAreaLabel;
  return /*#__PURE__*/React.createElement(StyledIncludedIcon, {
    "aria-label": includedAreaLabel,
    "data-test": "".concat(baseTestId, "-checkmark")
  });
};
var ProductFeaturesListItem = function ProductFeaturesListItem(_ref3) {
  var name = _ref3.name,
    isIncluded = _ref3.isIncluded,
    baseTestId = _ref3.baseTestId,
    includedAreaLabel = _ref3.includedAreaLabel,
    excludedAreaLabel = _ref3.excludedAreaLabel;
  return /*#__PURE__*/React.createElement(StyledProductFeaturesListItem, {
    "data-test": "".concat(baseTestId, "-row"),
    isIncluded: isIncluded
  }, isIncluded ? /*#__PURE__*/React.createElement(IncludedIcon, {
    baseTestId: baseTestId,
    includedAreaLabel: includedAreaLabel
  }) : /*#__PURE__*/React.createElement(NotIncludedIcon, {
    excludedAreaLabel: excludedAreaLabel
  }), name);
};
export default ProductFeaturesListItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/ProductFeaturesList/ProductFeaturesListItem.js
// module id = 4064
// module chunks = 11